module.exports = __webpack_public_path__ + "static/media/icon_stay.3c416f7c.svg";